<template>
  <div class="account gray-6 bg old-globals">
    <nav-bar />
    <div class="content">
      <side-nav />
      <md-app class="profile">
        <md-app-drawer class="gray-1 bg" md-permanent="clipped">
          <md-list class="gray-1 bg">
            <md-list-item to="/account/profile">
              <md-icon>account_circle</md-icon>
              <span class="md-list-item-text">Profile</span>
            </md-list-item>

            <md-list-item to="/account/change-password">
              <md-icon>vpn_key</md-icon>
              <span class="md-list-item-text">Change password</span>
            </md-list-item>

            <!--
            Disable student purchase
            <billing-portal-link v-slot="{link, subscriptionState}">
              <md-list-item :href="link">
                <md-icon>payment</md-icon>
                <span class="md-list-item-text">
                  Payment
                </span>
                <md-icon v-if="subscriptionState.hasPaymentIssue" class="md-accent">error</md-icon>
              </md-list-item>
            </billing-portal-link>
            -->
          </md-list>
        </md-app-drawer>

        <md-app-content class="gray-1 bg">
          <router-view />
          <!-- <payment-prompt /> -->
        </md-app-content>
      </md-app>
    </div>
  </div>
</template>

<script>
import auth from '../../../lib/common/providers/auth';

import SideNav from '../../../lib/common/components/SideNav';
import NavBar from '../../../lib/common/components/NavBar';
// import PaymentPrompt from '../../components/payment/PaymentPrompt';
// import BillingPortalLink from '../../components/payment/BillingPortalLink';

export default {
  name: 'account',
  components: {
    SideNav,
    NavBar,
    // PaymentPrompt,
    // BillingPortalLink,
  },
  async created() {
    if (!(await auth.isAuthenticated())) {
      this.$router.push({ name: 'login' });
    }
    this.$analytics.event('Account', 'account_page');
  }
};
</script>

<style scoped>
.account {
  display: flex;
  flex-direction: column;
}
.content {
  flex: 1;
}
.md-app {
  height: 100%;
}

.md-app-drawer {
    width: 250px;
}
</style>
